module.exports = __webpack_public_path__ + "img/reaction-link-logo-web.402005f6.png";